import { z } from "zod";

const translationPath = "components.settingsCache.searchCacheKey.errors.";

export const searchCacheKeySchema = z.object({
  key: z.string().nonempty(translationPath + "cache_key"),
});

export type TSearchCacheKeyForm = z.infer<typeof searchCacheKeySchema>;
